import React from "react";
import '../../assets/css/Tour360.css'

const CourtyardTour360 = () => {
    const preventIframeRedirect = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    return (
        <div className="courtyard-tour full-container">
            <iframe title="360 tour" src="https://surbhi-infotech-360.s3.ap-south-1.amazonaws.com/Courtyard_One/index.htm" widh={"100%"} height={"100%"} className="tour-iframe" onDoubleClick={preventIframeRedirect} allow="xr-spatial-tracking fullscreen" />
        </div>
    )
}

export default CourtyardTour360;